import React from 'react';
import { useRecoilValue } from 'recoil';
import AccessInfoSelector from '../../recoil/selectors/AccessInfoSelector';

export default function Convert() {
  const { network } = useRecoilValue(AccessInfoSelector);

  switch (network) {
    case 'meetme':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1559091827329#ic_convert" /></svg>
      );

    case 'lovoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_lv_claim_credit" /></svg>
      );

    case 'vidoo':
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_vidoo_convert" /></svg>
      );

    default:
      return (
        <svg><use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="img/icons/economy.svg?1510677573844#ic_convert" /></svg>
      );
  }
}
